import { useState } from 'react';
export function useToggleOpen(initialValue = false, openCallback, closeCallback) {
    const [value, setValue] = useState(initialValue);
    const open = () => {
        setValue(true);
        if (openCallback)
            openCallback();
    };
    const close = () => {
        setValue(false);
        if (closeCallback)
            closeCallback();
    };
    return [value, open, close];
}
